<script setup lang="ts">
export type PlanData = {
  name: string
  description: string
  shortcode?: string
}

// TODO: avoid params in view
const props = defineProps<{
  planData?: PlanData
}>()
</script>

<template>
  <div class="text-neutral-700 text-sm pt-2">
    <div class="font-bold sm:w-1/2 w-full">{{ props.planData?.name }}</div>
    <div class="ml-auto w-full">
      <div class="md-styling" v-html="props.planData?.description" />
    </div>
  </div>
</template>

<style scoped>
@reference "#tailwind";

div.md-styling ul li {
  @apply ml-4;
}

div.md-styling ul {
  @apply list-disc; /* not used? */
}
</style>
